import React from 'react'

function LeagueSelectorListItem({league, selectedLeague, setSelectedLeague}) {

    

    return (
        <li onClick={() => setSelectedLeague(league)} className="list-group-item">
            {league?.name} - {league?.country} <span className="float-right"><i className={`fas fa-${league.league_id === selectedLeague?.league_id ? "check text-success" : "plus"}`}></i> </span>
        </li>
    )
}
export default LeagueSelectorListItem